import AdminUpdatePasein from "../../components/AdminPasien/AdminPasienUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
